import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisV, faTimesCircle } from '@fortawesome/free-solid-svg-icons'

import { Menu, Item, Separator, MenuProvider } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.min.css';

import modalStyle from './modalStyle.js';
import './Box.scss';

let box_count = 0;


class Box extends Component {
	constructor(props) {
		super(props);
		this.box_id = box_count++;
		this.state = {
			modalIsOpen: false
		}
		
		this.optionsClick = this.optionsClick.bind(this);
		
		this.openModal = this.openModal.bind(this);
		this.afterOpenModal = this.afterOpenModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	openModal() {
		this.setState({modalIsOpen: true});
	}

	afterOpenModal() {
	// references are now sync'd and can be accessed.
	}

	closeModal() {
		this.setState({modalIsOpen: false});
	}
	
	optionsClick(e) {
		this.openModal();
	}
	
	callbackWrapper(i, e, p) {
		console.log("callbackWrapper", i, e, p);
		this.closeModal();
		if (this.props.options[i].callback)
			this.props.options[i].callback(e);
	}
	
	render() {
		const noop = ()=>{};
		let options = [];
		if (this.props.options) {
			//options.push(<button className="actions-menu clear" key="button" onClick={this.optionsClick}><FontAwesomeIcon icon={faEllipsisV}/></button>);
		// Maybe clicking this should open a modal...
			let inner = [];
			for(let i = 0; i < this.props.options.length; i++) {
				if (this.props.options[i] === false) continue;
				//inner.push(<button key={i} className="option block" onClick={this.callbackWrapper.bind(this, i)}>{this.props.options[i].label}</button>);
				inner.push(<Item key={i} onClick={this.callbackWrapper.bind(this, i)}>{this.props.options[i].label}</Item>);
				if (this.props.options[i].separator)
					inner.push(<Separator key={"separator_" + i} />);
			}
			options.push(<span key="options">
					<MenuProvider id={"box_options_" + this.box_id} event="onClick">
						<button className="actions-menu clear" key="button" type="button"><FontAwesomeIcon icon={faEllipsisV}/></button>
					</MenuProvider>
					<Menu id={"box_options_" + this.box_id} theme="dark">{inner}</Menu>
				</span>);
			
	/*		options.push(<Box 
					modal={true}
					key="modal"
					isOpen={this.state.modalIsOpen}
					onAfterOpen={this.afterOpenModal}
					onRequestClose={this.closeModal}
					title={this.props.modalTitle || "Options"}
				>
					{inner}
			</Box>);*/
		}
		
		if (this.props.modal) {
			options.push(<button key="close" className="close clear" onClick={this.props.onRequestClose || noop}><FontAwesomeIcon icon={faTimesCircle} /></button>);
			return <Modal
				isOpen={this.props.isOpen}
				onAfterOpen={this.props.onAfterOpen || noop}
				onRequestClose={this.props.onRequestClose || noop}
				contentLabel={this.props.title || "Options"}
				style={modalStyle}>
					<div className="box-style">
						<div className="heading">
							<h2>{this.props.title || ''}</h2>
							{options}
						</div>
						<div className="content">
							{this.props.children}
						</div>
					</div>
				</Modal>;
		}
		const o = [
			<div key="heading" className="heading">
				<h2>{this.props.title || ''}</h2>
				{options}
			</div>,
			<div key="content" className="content">
				{this.props.children}
			</div>
		];
		if (this.props.to) 
			return <Link className={"Box box-style " + (this.props.className || "")} to={this.props.to}>{o}</Link>;
		return <div className={"Box box-style " + (this.props.className || "")}>{o}</div>
	}
}

export default Box;